import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { UserContext } from "components/ProjectSpecificComponents/Contexts/UserContext"
import React, { useContext, useState } from "react"
import ReactTooltip from "react-tooltip"
import Tooltip from "../Tooltip/Tooltip"
import { IIconProps } from "./Icon/Interfaces"

const UserIcon = ({ width = 21, height = 22, strokeColor = "var(--gray)" }: IIconProps) => {
	const { user } = useContext(UserContext)

	const userInfoText = `${user?.fullName}`

	return (
		<>
			<HyperDiv
				width={width}
				height={height}
				centeredY
				style={{ paddingRight: "5px" }}
				data-for="UserInfo"
				data-tip={userInfoText}
			>
				<svg
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="user-large"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 512 512"
				>
					<path
						fill={strokeColor}
						d="M256 288c79.53 0 144-64.47 144-144s-64.47-144-144-144c-79.52 0-144 64.47-144 144S176.5 288 256 288zM351.1 320H160c-88.36 0-160 71.63-160 160c0 17.67 14.33 32 31.1 32H480c17.67 0 31.1-14.33 31.1-32C512 391.6 440.4 320 351.1 320z"
					></path>
				</svg>
			</HyperDiv>
			<ReactTooltip id="UserInfo" />
		</>
	)
}

export default UserIcon
